import { InboxOutlined } from '@ant-design/icons';
import { Button, message, Spin, Upload } from 'antd';
import 'antd/dist/reset.css';
import { ProgressProps } from 'antd/lib/progress';
import { UploadChangeParam } from 'antd/lib/upload';
import { RcFile, UploadFile, UploadListType } from 'antd/lib/upload/interface';
import { observer } from 'mobx-react';
import React from 'react';
import ImageUploaderStore from '../../stores/common/image-uploader';
import { v4 as uuidv4 } from 'uuid';

const { Dragger } = Upload;

const ImageUploader: React.FC<{ uploader: ImageUploaderStore, callback?: () => any }> = ({ uploader, callback }) => {

    const handlePhotoPaste = async () => {
        try {

            if (!navigator.clipboard?.read) {
                message.warning('Ваш браузер не поддерживает чтение буфера');
                return;
            }

            const clipboardItems = await navigator.clipboard.read();

            for (const item of clipboardItems) {

                const imageType = item.types.find(type => type.startsWith('image/'));
                if (!imageType) continue;

                const blob = await item.getType(imageType);
                const fileExtension = imageType.replaceAll('image/', "");

                const file: UploadFile = {
                    name: "image." + fileExtension,
                    size: blob.size,
                    type: imageType,
                    uid: uuidv4(),
                    originFileObj: blob as RcFile
                };
                
                uploader.handleManualUpload(file, callback);
            }
        } catch (error) {
            message.error('Не удалось получить изображение из буфера');
            console.error('Clipboard error:', error);
        }
    }

    const antUploaderProps = {
        name: 'file',
        multiple: true,
        listType: 'picture' as UploadListType,
        action: uploader.url,
        progress: 'line' as ProgressProps,
        fileList: uploader.files,
        disabled: uploader.inactive,
        onChange(info: UploadChangeParam<UploadFile<any>>) {
            uploader.handleOnChange(info, callback);
        }
    };

    const dragger = <div>
        <Button color="primary" variant="outlined" onClick={handlePhotoPaste} style={{ marginBottom: "10px" }}
            disabled={uploader.inactive || uploader.loading}>
            Вставить скопированное
        </Button>
        <Dragger className={uploader.inactive || uploader.loading ? "inactive-element" : ""} {...antUploaderProps}>
            <p className="ant-upload-drag-icon"><InboxOutlined /></p>
            <p className="ant-upload-text">Сюда можно перетащить фото, вставить по Ctrl+V или кликнуть чтобы открыть окно поиска файлов</p>
            <p className="ant-upload-hint">Поддерживает загрузку нескольких изображений в формате PNG, JPEG</p>
        </Dragger>
    </div>;

    return (
        <div>
            {uploader.loading
                ? <Spin size='large' tip="Загрузка...">{dragger}</Spin>
                : dragger
            }
        </div>
    );
};

export default observer(ImageUploader);